import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AdminHeader = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-[#1a1a1a] border-b border-[#4d4d4d] sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo/Brand */}
          <div className="flex items-center">
            <Link to="/admin" className="text-xl font-bold text-white">
              Admin Panel
            </Link>
            <span className="ml-3 text-sm text-gray-400">Koby Pierce Portfolio</span>
          </div>

          {/* Navigation */}
          <nav className="flex space-x-4">
            {/* Main Dashboard */}
            <Link
              to="/admin"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive('/admin')
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:text-white hover:bg-[#2a2a2a]'
              }`}
            >
              Overview
            </Link>

            {/* Sub-Dashboards */}
            <div className="flex space-x-2">
              <Link
                to="/admin/blog-dashboard"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive('/admin/blog-dashboard') || isActive('/admin/blog') || isActive('/admin/blog-stats')
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-300 hover:text-white hover:bg-[#2a2a2a]'
                }`}
              >
                Blog
              </Link>
              <Link
                to="/admin/todo-dashboard"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive('/admin/todo-dashboard')
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-300 hover:text-white hover:bg-[#2a2a2a]'
                }`}
              >
                To-Do
              </Link>
              <Link
                to="/admin/school-dashboard"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive('/admin/school-dashboard')
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-300 hover:text-white hover:bg-[#2a2a2a]'
                }`}
              >
                School
              </Link>
            </div>

            {/* Other Tools */}
            <div className="border-l border-[#4d4d4d] pl-4 flex space-x-2">
              <Link
                to="/admin/contacts"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive('/admin/contacts')
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-300 hover:text-white hover:bg-[#2a2a2a]'
                }`}
              >
                Messages
              </Link>
              <Link
                to="/"
                className="px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-white hover:bg-[#2a2a2a] transition-colors"
              >
                ← Site
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader; 